import { render } from "./index.vue?vue&type=template&id=2048ca86&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=2048ca86&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lidu/礼度管理后台-CRA端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2048ca86"]])

export default __exports__